import api from './api';

export const nablConfigService = {
  /**
   * Fetch investigations with NABL/accreditation mapping for a centre
   * @param {Object} params - { centreId, categoryId, subCategoryId, search, businessZoneId, stateId, cityId, accreditationFilter }
   */
  getNablInvestigations: async (params) => {
    const response = await api.get('/nabl-config', { params });
    return response.data;
  },

  /**
   * Batch save investigation accreditation mapping
   * @param {Object} data - { centreId, items: [{ subCategoryId, investigationId, isNabl }] }
   */
  saveBatch: async (data) => {
    const response = await api.post('/nabl-config/batch-save', data);
    return response.data;
  },

  /**
   * Retrieve centre accreditation logos
   * @param {number|string} centreId
   */
  getLogos: async (centreId) => {
    const response = await api.get(`/nabl-config/logos/${centreId}`);
    return response.data;
  },

  /**
   * Upload centre accreditation logo (NABL, CAP, NABH)
   * @param {Object} data - { centreId, logoType: 1|2|3, base64Image, fileName }
   */
  uploadLogo: async (data) => {
    const response = await api.post('/nabl-config/logos/upload', data);
    return response.data;
  }
};

export default nablConfigService;
